module.exports = __webpack_public_path__ + "media/images/brand/new_stuff_letter/cowgor_x2-24e55c2aafb1b9541dd2ebe253243cb5.jpg";